export const addTimestamp = (url: string) => `${url}?t=${Date.now()}`;
